<template>
  <div>
    <label class="d-block">
      {{ $t(`commands.panels.${config.label}`) }}
    </label>
    <validation-provider
      :name="config.label"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        label="name"
        :options="panels"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val.device.id"
        input-id="panels"
        :multiple="multiple"
        @input="panelSelected($event)"
      />
      <!-- <p class="mb-0 small">{{ config.label }}</p> -->
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { EventBus } from "@/libs/event-bus";
import { ValidationProvider } from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
      panels: []
    };
  },
  created() {
    this.model = this.value;
  },
  async mounted() {
    const urlPanels = {
      'dmp_panel': 'dmp_panels/getAll',
      'intelbras_panel': 'intelbras_panels/getAll',
      'pacom_panel': 'pacom_sites/getAll'
    }

    if (this.model) {
      EventBus.emit('panel-selected', this.model);
    }

    const { data } = await store.dispatch(urlPanels[this.config.subtype]);

    this.panels = data;
  },
  methods: {
    panelSelected(data) {
      this.$emit('input', data);
      EventBus.emit('panel-selected', data);
    }
  }
};
</script>

<style></style>
